import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks';
import Breadcrumbs from '../../../components/breadcrumbs/Breadcrumbs';
import { FORM_SECTION_ROUTES } from '../constants';
import { componentKey } from './BatchImportSlice';
import BatchImportStepper from './batchimportstepper/BatchImportStepper';
import SelectYearFormType from './selectyearformtype/SelectYearFormType';
import { PermissionReroute, useUserPermissionsInfo } from '../../dashboard/hooks/userHooks';
import { PAGE_PATH, PAGE_PERMISSIONS } from '../../dashboard/constants/constant';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';

export default function BatchImport(){
    useGarbageCollector(componentKey);
    const { isYearFormTypeSelected } = useSelector((state) => state[componentKey]);
    const { permissions } = useUserPermissionsInfo();
    const navigate = useTxNavigate();
    
    useEffect(()=>{
        PermissionReroute(PAGE_PERMISSIONS.IMPORT_DATA, permissions, navigate, PAGE_PATH.DASHBOARD)
    },[permissions])

    return <>
        <div>
            <Breadcrumbs items={[
                    { text: 'Home', link: '/' },
                    { text: 'Forms', link: `/${FORM_SECTION_ROUTES.FORMS}` },
                    { text: 'Import' },
                    { text: 'Excel Spreadsheet' },
                ]} 
            />
            {
                !isYearFormTypeSelected ? <SelectYearFormType /> : <BatchImportStepper />
            }
        </div>
    </>
}